exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contentful-osoba-imie-nazwisko-js": () => import("./../../../src/pages/{ContentfulOsoba.imieNazwisko}.js" /* webpackChunkName: "component---src-pages-contentful-osoba-imie-nazwisko-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-o-projekcie-js": () => import("./../../../src/pages/o-projekcie.js" /* webpackChunkName: "component---src-pages-o-projekcie-js" */)
}

